import { render, staticRenderFns } from "./ChartShipment.vue?vue&type=template&id=3112efcc&scoped=true&"
import script from "./ChartShipment.vue?vue&type=script&lang=js&"
export * from "./ChartShipment.vue?vue&type=script&lang=js&"
import style0 from "./ChartShipment.vue?vue&type=style&index=0&id=3112efcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112efcc",
  null
  
)

export default component.exports
import {QCard,QCardSection,QDialog,QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QPageContainer,QPage,QTable,QTh,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QDialog,QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QPageContainer,QPage,QTable,QTh}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
